import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GarantieLegalCheckFormModel } from '../../factories/garantie-legal-check-form.factory';

@Component({
  selector: 'app-legal-checks',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './legal-checks.component.html',
  styleUrl: './legal-checks.component.scss'
})
export class LegalChecksComponent {

  @Input() formGroup!: FormGroup<GarantieLegalCheckFormModel>;

  @Input() isPremiumSchutz: boolean = false;
}
